export interface AttackData {
  id: number;
  name: string;
  power: number;
}

export interface CreatureData {
  id?: number;
  template_name: string;
  sprite_key: string;
  sprite_url?: string;
  level: number;
  xp?: number;
  xp_next?: number;
  hp: number;
  current_hp?: number;
  max_hp: number;
  atk: number;
  def_: number;
  spd: number;
  attacks: AttackData[];
}

export interface CombatEvent {
  type: string;
  message: string;
  attack?: string;
  damage?: number;
  xp?: number;
}

export const FONT = "'Nunito', sans-serif";

export const UI = {
  BG: 0x2d2213,
  PANEL: 0x3e2f1c,
  BUTTON: 0x5a4230,
  BUTTON_HOVER: 0x7a5a40,
  ACCENT: 0xf5c242,
  HP_GREEN: 0x27ae60,
  HP_RED: 0xe74c3c,
  TEXT: "#f0e6d0",
  TEXT_DARK: "#2d2213",
};

/** Carga sprites de criaturas en Phaser. Llama onComplete cuando termina. */
export function loadCreatureSprites(
  scene: Phaser.Scene,
  creatures: { sprite_key: string; sprite_url?: string }[],
  onComplete: () => void,
): void {
  let needsLoad = false;
  for (const c of creatures) {
    const key = `creature_${c.sprite_key}`;
    if (c.sprite_url && !scene.textures.exists(key)) {
      scene.load.image(key, c.sprite_url);
      needsLoad = true;
    }
  }
  if (needsLoad) {
    scene.load.once("complete", onComplete);
    scene.load.start();
  } else {
    onComplete();
  }
}

/** Muestra el sprite de una criatura. Si no tiene textura, dibuja un círculo fallback. */
export function addCreatureSprite(
  scene: Phaser.Scene,
  x: number,
  y: number,
  spriteKey: string,
  size: number,
): Phaser.GameObjects.Image | Phaser.GameObjects.Arc {
  const textureKey = `creature_${spriteKey}`;
  if (scene.textures.exists(textureKey)) {
    return scene.add.image(x, y, textureKey).setDisplaySize(size, size);
  }
  return scene.add.circle(x, y, size / 2, 0xcccccc);
}
